import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import LandClassificationsContent from './LandClassificationsContent';
import CreateModal from '../modals/CreateModal';
import UpdateModal from '../modals/UpdateModal';

const form = {
  keyword: '',
};

function LandClassificationsContainer({
  match,
  history,
  getLandClassificationsList,
  classificationList,
  isLoading,
  removeLandClassification,
  classificationListPager,
  getSingleLandClass,
  ordinanceRevisionId,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Classification Code',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Classification Code',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove this Classification code?',
      () => {
        removeLandClassification(data.id, () => {
          getLandClassificationsList();
          const id = _.get(classificationList, '0.id');
          history.push(`/rpt/land/land-settings/land-classification/${id}`);
          getSingleLandClass(id);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getLandClassificationsList();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };
  useEffect(() => {
    if (debouncedSearchTerm) {
      getLandClassificationsList({ name: formData.keyword });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:classificationId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Land Classifications"
            getData={getLandClassificationsList}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:classificationId?`}
            listName="classificationCodes"
            label="Land Classifications"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.classificationId}
            data={classificationList}
            dataPager={classificationListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:classificationId?`}
                    render={() => (
                      <LandClassificationsContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        handleRemove={handleRemove}
                        ordinanceRevisionId={ordinanceRevisionId}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:classificationId?`}
                  render={() =>
                    !params.classificationId && classificationList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(classificationList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

LandClassificationsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  classificationList: PropTypes.instanceOf(Array).isRequired,
  classificationListPager: PropTypes.instanceOf(Object).isRequired,
  removeLandClassification: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  getSingleLandClass: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  classificationList: _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.list`) || [],
  classificationListPager: _.get(api, `${c.GET_LAND_CLASSIFICATIONS}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_LAND_CLASSIFICATIONS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(LandClassificationsContainer);
